import SearchTable from './src/SearchTable'
export default SearchTable